import React, { useState, useEffect } from 'react';
import { Modal, Form, Alert } from 'react-bootstrap';
import { apiFetch } from '../api';
import ContractFiles from './ContractFiles';
import {
  emptyContractForm,
  contractToForm,
  updateContractFormField,
  buildContractPayload,
} from '../utils/contractForm';
import ContractFormFields from './ContractFormFields';

function ContractEditModal({ show, onHide, contract, onSaved, onDelete }) {
  const [form, setForm] = useState(emptyContractForm());
  const [file, setFile] = useState(null);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (show && contract) {
      setForm(contractToForm(contract));
      setFile(null);
      setError('');
    }
  }, [show, contract]);

  const handleChange = (field, value) => {
    setForm((prev) => updateContractFormField(prev, field, value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!contract) {
      setError('Договор не найден');
      return;
    }
    setError('');
    setSaving(true);
    try {
      const payload = buildContractPayload(form, { includeProgress: true });
      let data;
      if (file) {
        const fd = new FormData();
        Object.entries(payload).forEach(([key, val]) => fd.append(key, val));
        fd.append('file', file);
        data = await apiFetch(`/api/contracts/${contract.id}/`, {
          method: 'PATCH',
          body: fd,
        });
      } else {
        data = await apiFetch(`/api/contracts/${contract.id}/`, {
          method: 'PATCH',
          body: JSON.stringify(payload),
        });
      }
      onSaved(data);
      onHide();
    } catch (err) {
      setError(err.message || 'Ошибка сохранения');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton className="app-surface">
        <Modal.Title>Редактировать договор</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body className="app-surface">
          {error && <Alert variant="danger">{error}</Alert>}
          <ContractFormFields form={form} onChange={handleChange} showProgress />

          {contract && (
            <div className="mt-3">
              <Form.Label>Прикреплённые файлы</Form.Label>
              <ContractFiles contractId={contract.id} showUpload={true} compact={false} />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="app-surface d-flex">
          {onDelete && (
            <button type="button" className="app-btn app-btn-danger-outline me-auto" onClick={onDelete}>
              Удалить договор
            </button>
          )}
          <button type="button" className="app-btn" onClick={onHide}>Отмена</button>
          <button type="submit" className="app-btn app-btn-primary" disabled={saving}>
            {saving ? 'Сохранение...' : 'Сохранить'}
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default ContractEditModal;